import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Box,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import SummarizeIcon from "@mui/icons-material/Summarize";
import axios from "../../../../axios-order";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import { useLocation } from "react-router-dom";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { canWrite } from '../../../../utils/privilegeUtils';


function HsnSummaryDetails() {
  const location = useLocation();
  const [selectedReportBy, setSelectedReportBy] = useState("hsn/sac_wise");
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [summaryDetails, setSummaryDetails] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});

  const [exportLoading, setExportLoading] = useState(false);

  const SOURCE_TYPE_MAP = {
    hsn_b2b: "B2B",
    hsn_b2c: "B2C",
    hsn_data: "DATA"
  };

  const toggleRow = (index) => {
    // Log the current state before and after toggling
    console.log("Before toggle:", expandedRows);

    setExpandedRows(prevState => {
      const newState = {
        ...prevState,
        [index]: !prevState[index], // Toggle the expansion for the row
      };

      // Log the new state after toggling
      console.log("After toggle:", newState);
      return newState;
    });
  };


  const downloadBase64File = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };


  const handleExportExcel = () => {
      setExportLoading(true);
    axios.post(`/hsn_summary_excel`, { report_id: reportData })
      .then((response) => {
        const contentType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const base64Data = response.data.file;
        if (base64Data) {
          downloadBase64File(contentType, base64Data, "HSNSummaryReport.xlsx");
        } else {
          console.error("Base64 data is missing in the response");
        }
      })
      .catch((error) => {
        console.log(error)
      })
       .finally(() => setExportLoading(false));
  };

  useEffect(() => {
    const item = location.state?.items || {};
    setReportData(item);
    console.log("Passed item:", item);
  }, [location]);

  useEffect(() => {
    if (reportData) {
      setLoading(true);
      axios
        .get(`/summary_fetched_from_hsn/${reportData}`)
        .then((response) => {
          setSummaryDetails(response.data);

          setLoading(false);
        })
        .catch((err) => {
          console.error("Error fetching API data:", err);
          setError("Failed to fetch data");
          setLoading(false);
        });
    }
  }, [reportData]);


  const numberFormat = (value) => {

    if (value === "(Blank)" || value === null) {
      return "₹ 0";
    }

    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumSignificantDigits: 10,
    }).format(value);
  };
  const groupedData = summaryDetails?.data?.hsn_processed?.reduce((acc, item) => {
    const key = item.source_type;
    if (!acc[key]) acc[key] = [];
    acc[key].push(item);
    return acc;
  }, {}) || {};

  const orderedGroups = ["hsn_b2b", "hsn_b2c", "hsn_data"];
  const cellCenter = {
    border: "1px solid #c1c1c1",
    padding: "8px",
    textAlign: "center",
    whiteSpace: "nowrap",
  };

  const cellRight = {
    border: "1px solid #c1c1c1",
    padding: "8px",
    textAlign: "right",
    whiteSpace: "nowrap",
  };
  const handleBack = () => {
    window.history.back();
  };




  return (
    <Container maxWidth={false}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "2%",
          padding: "0 2%",
        }}

      >
        <button
          className="button-outlined-primary"
          style={{ marginLeft: "0px", width: "15%", marginTop: "1px" }}
          onClick={handleBack}
        >
          BACK
        </button>
        <div
          style={{
            flex: "1",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginLeft: "14%",
          }}
        >
          <Typography
            variant="h6"
            sx={{ fontWeight: "bold", textAlign: "center" }}
          >
            HSN SUMMARY REPORT{" "}
            <SummarizeIcon style={{ marginBottom: "4px", color: "#043010" }} />
          </Typography>
        </div>
        <FormControl
          style={{ flex: "1", minWidth: 250, maxWidth: "20%" }}
          variant="outlined"
        >
          <InputLabel>Report By</InputLabel>
          <Select
            value={selectedReportBy}
            onChange={(e) => setSelectedReportBy(e.target.value)}
            label="Report By"
            fullWidth
            style={{ height: "44px" }}
          >
            <MenuItem value="hsn/sac_wise">
              HSN/SAC Wise Report-as per GSTR1
            </MenuItem>
            <MenuItem value="hsn/comparison">
              HSN Comparison Report-Books vs GSTR1
            </MenuItem>
          </Select>
        </FormControl>
        <Button
          onClick={handleExportExcel}
          variant="contained"
          color="primary"
          style={{ marginLeft: "2%" }}
          endIcon={!exportLoading && <FileDownloadIcon />}
          disabled={exportLoading}
        >
          {exportLoading ? "Exporting…" : "Export"}
        </Button>
        {/* <Button
          onClick={handleExportExcel}
          variant="contained"
          color="primary"
          style={{ marginLeft: "2%" }}
          endIcon={<FileDownloadIcon />}
        >
          Export
        </Button> */}
      </div>

      <BoxWrapper
        style={{ width: "100%", maxWidth: "100%" }}
        boxTitle={
          selectedReportBy === "hsn/sac_wise"
            ? "HSN/SAC Wise Report-as per GSTR1"
            : "HSN Comparison Report-Books vs GSTR1"
        }
      >
        {loading ? (
          <div
            style={{
              color: "black",
              textAlign: "center",
              fontWeight: "bold",
              padding: "20px",
              fontSize: "16px",
            }}
          >
            Loading… Please wait
          </div>
        ) : error ? (
          <p>{error}</p>
        ) : !summaryDetails || !summaryDetails.data ? (
          <div
            style={{
              color: "red",
              textAlign: "center",
              fontSize: "16px",
              padding: "20px",
            }}
          >
            No data found!
          </div>
        ) : selectedReportBy === "hsn/sac_wise" &&
          summaryDetails.data.hsn_processed ? (
          <>
            {Object.keys(groupedData).map((groupKey) => {
              const groupItems = groupedData[groupKey];
              if (!groupItems || groupItems.length === 0) return null;
              return (
                <Box key={groupKey} sx={{ mb: 4 }}>
                  <Typography
                    variant="h6"
                    gutterBottom
                    style={{ textTransform: "uppercase" }}
                  >
                    {SOURCE_TYPE_MAP[groupKey]?.toUpperCase() ||
                      groupKey.replace("hsn_", "").toUpperCase()}
                  </Typography>
                  <div >
                    <div style={{ maxHeight: "400px", overflowY: "auto", }}>
                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          fontFamily: "Arial, sans-serif",
                          fontSize: "13px",
                          tableLayout: "fixed",
                        }}
                      >
                        <thead>
                          <tr style={{ backgroundColor: "#d6e3f3", position: "sticky", top: 0, zIndex: 2 }}>
                            {[
                              "Source Type",
                              "HSN Code",
                              "Rate (%)",
                              "UQC",
                              "Quantity",
                              "Taxable Value",
                              "SGST",
                              "CGST",
                              "IGST",
                              "CESS",
                              "FP",
                            ].map((heading, i) => (
                              <th
                                key={i}
                                style={{
                                  border: "1px solid #3b6ea5",
                                  padding: "8px",
                                  textAlign: "center",
                                  fontWeight: "bold",
                                  color: "#002060",
                                  whiteSpace: "nowrap",
                                  background: "#d6e3f3",
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 3,
                                }}
                              >
                                {heading}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {groupItems.map((item, index) => (
                            <tr key={index}>
                              <td style={cellCenter}>
                                {(SOURCE_TYPE_MAP[item.source_type] || item.source_type || "N/A").toUpperCase()}
                              </td>
                              <td style={cellCenter}>{item.hsn_code || "—"}</td>
                              <td style={cellRight}>{item.rate ?? 0}</td>
                              <td style={cellCenter}>{item.uqc || "—"}</td>
                              <td style={cellRight}>{item.quantity ?? 0}</td>
                              <td style={cellRight}>{numberFormat(item.taxable_value)}</td>
                              <td style={cellRight}>{numberFormat(item.sgst)}</td>
                              <td style={cellRight}>{numberFormat(item.cgst)}</td>
                              <td style={cellRight}>{numberFormat(item.igst)}</td>
                              <td style={cellRight}>{numberFormat(item.cess)}</td>
                              <td style={cellCenter}>{item.fp || "—"}</td>
                            </tr>
                          ))}
                        </tbody>

                      </table>
                    </div>
                  </div>

                </Box>
              );
            })}
          </>
        ) : selectedReportBy === "hsn/comparison" &&
          summaryDetails.data.hsn_comparison ? (
          <div className="responsive-table" style={{ maxHeight: "500px" }}>
            <table
              className="summary-tab-single-year-table-css"
              style={{ tableLayout: "auto", width: "120%" }}
            >
              <thead>
                <tr>
                  <th colSpan={2} style={{ backgroundColor: "#d6712d", color: "white" }}>
                    FILING PERIOD
                  </th>
                  <th colSpan={7} style={{ backgroundColor: "#3065d1", color: "white" }}>
                    AS PER BOOKS
                  </th>
                  <th colSpan={8} style={{ backgroundColor: "#1ed457", color: "white" }}>
                    AS PER GSTR1
                  </th>
                </tr>
                <tr>

                  <th></th>
                  <th>Month</th>
                  <th>HSN Code</th>
                  <th>Quantity</th>
                  <th>Taxable Value</th>
                  <th>CGST</th>
                  <th>SGST</th>
                  <th>IGST</th>
                  <th>CESS</th>
                  <th>HSN Code</th>
                  <th>Quantity</th>
                  <th>Taxable Value</th>
                  <th>CGST</th>
                  <th>SGST</th>
                  <th>IGST</th>
                  <th>CESS</th>
                </tr>
              </thead>
              <tbody>
                {summaryDetails.data.hsn_comparison.map((item, index) => {
                  const months = Object.keys(item).filter((key) => key !== "hsn_code");
                  return (
                    <React.Fragment key={index}>
                      <tr>
                        <td>
                          <button
                            onClick={() => toggleRow(index)}
                            style={{ border: "none", background: "none", cursor: "pointer" }}
                          >
                            {expandedRows[index] ? (
                              <ArrowDropUpIcon style={{ color: "#2dcc42" }} />
                            ) : (
                              <ArrowDropDownIcon style={{ color: "#2b3ec2" }} />
                            )}
                          </button>
                        </td>
                        {months.map((month) => {
                          const monthData = item[month]?.total_value || null;
                          return (
                            <React.Fragment key={month}>
                              <td>{month}</td>
                              {monthData ? (
                                <>
                                  <td></td>
                                  <td>{monthData.books_total_quantity}</td>
                                  <td>{numberFormat(monthData.books_total_taxable_value)}</td>
                                  <td>{numberFormat(monthData.books_total_cgst)}</td>
                                  <td>{numberFormat(monthData.books_total_sgst)}</td>
                                  <td>{numberFormat(monthData.books_total_igst)}</td>
                                  <td>{numberFormat(monthData.books_total_cess)}</td>
                                  <td></td>
                                  <td>{monthData.processed_total_quantity}</td>
                                  <td>{numberFormat(monthData.processed_total_taxable_value)}</td>
                                  <td>{numberFormat(monthData.processed_total_cgst)}</td>
                                  <td>{numberFormat(monthData.processed_total_sgst)}</td>
                                  <td>{numberFormat(monthData.processed_total_igst)}</td>
                                  <td>{numberFormat(monthData.processed_total_cess)}</td>
                                </>
                              ) : (
                                <td colSpan={12} style={{ textAlign: "center" }}>
                                  No Data
                                </td>
                              )}
                            </React.Fragment>
                          );
                        })}
                      </tr>
                      {expandedRows[index] &&
                        months.map((month) => {
                          const dividedData =
                            item[month]?.[`divided_value_${month.toLowerCase()}`] || [];
                          return (
                            <React.Fragment key={month}>
                              {dividedData.length > 0 ? (
                                dividedData.map((data, subIndex) => (
                                  <tr key={`sub-${subIndex}`}>
                                    <td></td>
                                    <td></td>
                                    <td>{data.books_hsn_code}</td>
                                    <td>{data.books_total_quantity}</td>
                                    <td>{numberFormat(data.books_taxable_value)}</td>
                                    <td>{numberFormat(data.books_total_cgst)}</td>
                                    <td>{numberFormat(data.books_total_sgst)}</td>
                                    <td>{numberFormat(data.books_total_igst)}</td>
                                    <td>{numberFormat(data.books_total_cess)}</td>
                                    <td>{data.hsn_code}</td>
                                    <td>{data.quantity}</td>
                                    <td>{numberFormat(data.taxable_value)}</td>
                                    <td>{numberFormat(data.cgst)}</td>
                                    <td>{numberFormat(data.sgst)}</td>
                                    <td>{numberFormat(data.igst)}</td>
                                    <td>{numberFormat(data.cess)}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="16" style={{ textAlign: "center" }}>
                                    No Divided Data Available for {month}
                                  </td>
                                </tr>
                              )}
                            </React.Fragment>
                          );
                        })}
                    </React.Fragment>
                  );
                })}
              </tbody>






            </table>
          </div>
        ) : (
          <div style={{ color: "red", textAlign: "center", fontSize: "16px", padding: "20px" }}>
            No data found!
          </div>
        )}
      </BoxWrapper>

    </Container>
  );
};

export default HsnSummaryDetails;

